import { useCallback, useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import useWorkspaceDetails from '../../../../hooks/useWorkspaceDetails'
import { routePaths } from '../../../RootPage'
import SmartFunctionHeader from '../../components/SmartFunctionHeader'
import FlowCytometryReviewAnalysisSelectPanel, {
  flowCytometryReviewAnalysisPanels,
} from './FlowCytometryReviewAnalysisSelectPanel'
import SmartFunctionViewTypeDropdown, {
  SmartFunctionViewType,
} from '../../components/SmartFunctionViewTypeDropdown'

const FlowCytometryReviewAnalysisSmartFunctionDetailsPageHeader = () => {
  const navigate = useNavigate()
  const { workspaceId, algorithmRunId, viewType, panel } = useParams()

  const { selectedWorkspace } = useWorkspaceDetails({
    workspaceId,
    preventFetch: true,
  })

  const backButtonUrl = useMemo(
    () =>
      `${routePaths.WORKSPACE_DETAILS}/${selectedWorkspace?.id}/overview/smartFunction`,
    [selectedWorkspace?.id],
  )

  const onRunChange = useCallback(
    (algorithmRunId?: string) => {
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_CC_FC_REVIEW_ANALYSIS}/${workspaceId}/${algorithmRunId}/${viewType}/${flowCytometryReviewAnalysisPanels.GATE_REVIEW}`
      navigate(url)
    },
    [navigate, workspaceId, viewType],
  )

  const onViewTypeChange = useCallback(
    (newViewType: SmartFunctionViewType) => {
      const url = `${routePaths.WORKSPACE_SMART_FUNCTION_DETAILS_CC_FC_REVIEW_ANALYSIS}/${workspaceId}/${algorithmRunId}/${newViewType}/${panel}`
      navigate(url)
    },
    [navigate, workspaceId, algorithmRunId, panel],
  )

  return (
    <SmartFunctionHeader
      backButtonUrl={backButtonUrl}
      totalFound={0}
      hideTotalAndSearchLine={true}
      onRunChange={onRunChange}
      hideDataSource
      secondLineStartChildren={<FlowCytometryReviewAnalysisSelectPanel />}
      secondLineEndChildren={
        <SmartFunctionViewTypeDropdown
          onChange={onViewTypeChange}
          value={viewType as SmartFunctionViewType}
        />
      }
    ></SmartFunctionHeader>
  )
}

export default FlowCytometryReviewAnalysisSmartFunctionDetailsPageHeader
